import React, { lazy, Suspense, useContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { ToastContainer } from "./utils/toast";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import PrivateRoute from "./components/login/PrivateRoute";
import Loader from "./components/loader/Loader";
import Layout from "./layout/Layout";
import { AdminContext } from "./context/AdminContext";
const Login = lazy(() => import("./pages/Login"));
const SignUp = lazy(() => import("./pages/SignUp"));
const ForgetPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));

const LoginRoute = () => {
  const { state } = useContext(AdminContext);
  const isAuthenticated = Boolean(
    state.adminInfo?.email && state.adminInfo?.token
  );

  if (isAuthenticated) {
    return <Redirect to="/dashboard" />;
  }

  return <Login />;
};

const App = () => {
  return (
    <>
      <ToastContainer />
      <Router>
        <AccessibleNavigationAnnouncer />
        <Suspense fallback={<Loader />}>
          <Switch>
            <Route exact path="/login" component={LoginRoute} />
            <Route path="/signup" component={SignUp} />
            <Route path="/forgot-password" component={ForgetPassword} />
            <Route path="/reset-password/:token" component={ResetPassword} />

            <PrivateRoute path="/" component={Layout} />
          </Switch>
        </Suspense>
      </Router>
    </>
  );
};

export default App;
